import Button from "common/Buttons/Button";
import React, { CSSProperties, useContext, useState } from "react";
import LiveGroupSearchModal from "features/configuration/AccountsAndGroups/LiveGroupSearchModal";
import { typography } from "@shared/common/Themes/typography";
import { useSelector } from "react-redux";
import { openMessage } from "utils/misc";
import Link from "common/Typography/Link";
import { AnalyticsContext } from "analytics/AnalyticsProvider";
import { useIsOnboarding } from "utils/hooks/misc";
import { OnboardingStep } from "analytics/events";
import { sharedLib } from "@shared/services/shared.service";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface MissingGroupButtonProps {
  style?: CSSProperties;
  isLink?: boolean;
}

const MissingGroupButton = ({ style, isLink }: MissingGroupButtonProps) => {
  const { analytics } = useContext(AnalyticsContext);
  const user = useSelector(sharedLib.selectors.authentication.selectUser);
  const [showLiveGroupSearchModal, setShowLiveGroupSearchModal] =
    useState(false);
  const isExternalAccountWarning = !user?.hasExternalAccount();
  const isOnboarding = useIsOnboarding();
  const { t } = useTypedTranslation(LanguageNameSpaces.GROUPS);

  const onButtonClick = () => {
    analytics?.missingAGroupClicked({
      onboardingStep: isOnboarding ? OnboardingStep.METHOD_SETTINGS : undefined,
    });

    if (!isExternalAccountWarning) {
      setShowLiveGroupSearchModal(true);
    } else {
      openMessage(t("missing_group.warning"), "warning");
    }
  };

  const buttonStyles: CSSProperties = {
    fontSize: typography.fontSizes.S,
    ...style,
  };
  if (isExternalAccountWarning) {
    buttonStyles.opacity = 0.5;
    buttonStyles.cursor = "not-allowed";
  }

  const props = {
    onClick: onButtonClick,
    style: buttonStyles,
  };

  const text = t("missing_group.button");

  return (
    <>
      {isLink ? (
        <Link {...props}>{text}</Link>
      ) : (
        <Button {...props}>{text}</Button>
      )}
      <LiveGroupSearchModal
        open={showLiveGroupSearchModal}
        onCancel={() => setShowLiveGroupSearchModal(false)}
      />
    </>
  );
};

export default MissingGroupButton;
